<template>
  <div class="memlist-progress">
    <!-- Title (optional) -->
    <p v-if="title" class="progress-title">{{ title }}</p>

    <!-- Progress bar -->
    <div class="progress-wrapper">
      <div
        class="progress-bar"
        :style="{ width: progressPercent + '%' }"
      />
    </div>

    <!-- Numeric value for clarity -->
    <p class="progress-value">
      {{ $t('COMMON.COUNT') }}:
      <strong>{{ current_value }} / {{ max_value }}</strong>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'MemlistThinProgressBar',
  mixins: [toasts],
  props: {
    max_value: { type: Number, required: true },
    current_value: { type: Number, default: 0 },
    /** Optional text shown above the bar */
    title: { type: String, default: '' }
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'companies']),
    progressPercent() {
      if (!this.max_value) return 0;
      return Math.min(100, (this.current_value / this.max_value) * 100);
    }
  }
};
</script>

<style scoped>
/*************************
 * Layout & spacing
 *************************/
.memlist-progress {
  display: flex;
  flex-direction: column;
  gap: 0.4rem; /* space between title, bar, and value */
}

/*************************
 * Title
 *************************/
.progress-title {
  font-weight: 600;
  font-size: 0.875rem; /* 14px */
  margin: 0;
  color: #34495e;
}

/*************************
 * Bar wrapper (track)
 *************************/
.progress-wrapper {
  height: 0.5rem; /* thin */
  width: 100%;
  background-color: #f1f3f5;
  border-radius: 9999px; /* pill */
  overflow: hidden;
}

/*************************
 * Fill (bar)
 *************************/
.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b8dff 0%, #6ab9ff 100%);
  transition: width 0.3s ease;
}

/*************************
 * Value under bar
 *************************/
.progress-value {
  font-size: 0.8rem;
  margin: 0;
  color: #2c3e50;
  text-align: right; /* aligns with bar fill end */
}
</style>
